var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Page not found")]),_c('p',{staticClass:"danger"},[_vm._v("Error - route not found")])])
}]

export { render, staticRenderFns }